import { SButton } from '@strana-artw/ui-kit';
export default {
  name: 'RestorePasswordSuccess',
  components: {
    SButton: SButton
  },
  methods: {
    close: function close() {
      this.$modal.close();
    }
  }
};